import { render, staticRenderFns } from "./OtherServicePriceFormModal.vue?vue&type=template&id=5411ac44&"
import script from "./OtherServicePriceFormModal.ts?vue&type=script&lang=js&"
export * from "./OtherServicePriceFormModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports